export class SwipeInteractionEvents {
	public static readonly DRAGGING_STARTED: string = 'SwipeInteractionEvents::DRAGGING_STARTED';
	public static readonly DRAGGING_FINISHED: string = 'SwipeInteractionEvents::DRAGGING_FINISHED';
	public static readonly START_SPIN: string = 'SwipeInteractionEvents::START_SPIN';

	// Occurs when the dista
	public static readonly REEL_BOUNCE_BACK_STARTED: string = 'SwipeInteractionEvents::REEL_BOUNCE_BACK_STARTED';
	public static readonly REEL_BOUNCE_BACK_FINISHED: string = 'SwipeInteractionEvents::REEL_BOUNCE_BACK_FINISHED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionEvents.ts